import {Toast} from 'mint-ui';
import fetch from '@/common/util/fetch';
import {request} from '@/common/util/request';

let urls = {
    getUserInfo: '/insightH5/remote/userCenter/getUserInfo',
    // regUser: '/wechat/api/register',
    regUser: '/i/wechat/api/userregister',
    updateUser: '/i/wechat/user/updateuserinfo'
};

let actions = {
    getUserInfo: (context, dataObj) => {
        return fetch({
            'url': urls.getUserInfo,
            'params': dataObj ? dataObj : {}
        }).then((result)=>{
            let data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                context.commit('userInit', data);
            } else {
                Toast(data.error_msg || '获取用户信息失败，请稍后重试~');
            }
            return data;
        }).catch((error) => {
            Toast('服务器走丢了，请稍后重试~');
        });
    },
    userReg: (context, dataObj) => {
        return request({
            'url': urls.regUser,
            'params': dataObj
        }).then((result)=>{
            let data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                Toast({
                    message: '操作成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('userReg', dataObj);
            } else {
                Toast(data.error_msg || '用户注册失败，请稍后重试~');
            }
            return data;

        }).catch((error) => {
            Toast('页面暂时无法访问，请稍后重试！');
        });
    },
    userUpdate: (context, dataObj) => {
        return request({
            'url': urls.updateUser,
            'params': dataObj
        }).then((result)=>{
            let data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                Toast({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('userUpdate', dataObj);
            } else {
                Toast(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch((error) => {
            Toast('页面暂时无法访问，请稍后重试！');
        });
    },
    updateUName: (context, data) => {
        context.commit('updateUName', data);
    },
    updateUserImg: (context, data) => {
        context.commit('updateUserImg', data);
    },
    updateSex: (context, data) => {
        context.commit('updateSex', data);
    },
    updateProvince: (context, data) => {
        context.commit('updateProvince', data);
    },
    updateCity: (context, data) => {
        context.commit('updateCity', data);
    },
    updateProvinceName: (context, data) => {
        context.commit('updateProvinceName', data);
    },
    updateCityName: (context, data) => {
        context.commit('updateCityName', data);
    },
    updateGrade: (context, data) => {
    	context.commit('updateGrade', data);
    },
    updatePhone: (context, data) => {
        context.commit('updatePhone', data);
    },
    updatePhoneCode: (context, data) => {
        context.commit('updatePhoneCode', data);
    },
    updateMail: (context,data) => {
        context.commit('updateMail', data);
    },
    updateBirth: (context,data) => {
        context.commit('updateBirth', data);
    },
    updateAreaCode: (context,data) => {
        context.commit('updateAreaCode', data);
    }
}
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/userInfo/actions.js